import { defineStore } from 'pinia'
import { createPersonalPickupsState } from './state'
import { createPersonalPickupsActions } from './actions'

export const usePersonalPickupsStore = defineStore('personalPickups', () => {
    const state = createPersonalPickupsState()
    const actions = createPersonalPickupsActions(state)

    return {
        ...state,
        ...actions
    }
})
